var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppLayout',[_c('PageHeader',{attrs:{"title":_vm.$t('milling.form')}}),_c('custom-seat-form',{on:{"complete":_vm.onCustomFormComplete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }